import { useIsBoAdminRole } from 'hooks/useIsBoAdminRole'
import { useLocation, useNavigate } from 'react-router-dom'

// This hook manages the "admin" query parameter in the URL
export function useAdminQuery() {
  const location = useLocation()
  const navigate = useNavigate()
  const isAdminRole = useIsBoAdminRole()
  if (!isAdminRole) {
    return {
      isAdminView: false,
      toggleAdmin: () => {}, // No-op if the user is not an admin
    }
  }
  const searchParams = new URLSearchParams(location.search) // Get query parameters
  const isAdminView = searchParams.has('admin')

  const toggleAdmin = (enabled: boolean) => {
    const params = new URLSearchParams(location.search) // To modify query parameters

    if (enabled) {
      params.set('admin', '')
    } else {
      params.delete('admin')
    }

    navigate(`${location.pathname}?${params.toString()}`, {
      replace: true,
    })
  }

  return {
    isAdminView,
    toggleAdmin,
  }
}
